import { MerchantRawModel } from '@/api/api-raw-models/merchant-raw-model';
import { MerchantModel } from '@/models/MerchantModel';

export const mapMerchant = (x: MerchantRawModel): MerchantModel => ({
  id: x.id,
  name: x.name,
  active: x.active,
  autoOpen: x.auto_open,
  coverPhotoUrls: x.cover_photo_urls,
  curbsidePickup: x.curbside_pickup,
  fullAddress: x.full_address,
  latitude: x.latitude,
  logoUrl: x.logo_url,
  longitude: x.longitude,
  pickupText: x.pickup_text,
  rewardsEnabled: x.rewards_enabled,
  state: x.state,
  streetAddress: x.street_address,
  displayAddress: x.display_address,
  taxRate: x.tax_rate,
  timezone: x.timezone,
});
